export default __webpack_public_path__ + "static/media/AutoWF4.5d2b1940.png";